import type { QueryClient } from '@tanstack/query-core';

/** @deprecated Use `QueryClient` from `@tanstack/query-core` directly */
export type ThinkAlphaQueryClient = QueryClient;

export const ToQueryKey = Symbol('ToQueryKey');

export interface QueryKey {
    [ToQueryKey]: () => string | Record<string, unknown>;
}
